import store from "../../store/store";

export const componentKey = "DASHBOARD_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
    setDashboardGraphData: (state, action) => {
      state.dashboardGraphData = action.payload;
    },
    setFacilityDashboardData: (state, action) => {
      state.facilityData = action.payload;
    },
    setFacilityRooms: (state, action) => {
      state.facilityRooms = action.payload;
    },
    // Top ICD-10 / DSM codes for the dashboard card.
    setIcdSummary: (state, action) => {
      state.icdSummary = action.payload;
    },
  },
  initialReducerState: {
    dashboardData: {},
    dashboardGraphData: {},
    facilityData: {},
    facilityRooms: [],
    icdSummary: {},
  },
});

export const {
  setDashboardData,
  setDashboardGraphData,
  setFacilityDashboardData,
  setFacilityRooms,
  setIcdSummary,
} = actions;
